import * as yup from 'yup';

export const UsuarioDetalheSchema = yup.object().shape({
  usu_nome: yup.string().required('Campo é obrigatório'),
  usu_login: yup.string().required('Campo é obrigatório'),
});
